/**
 * navigation redux constants
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// redux action IDs
export const PUSH_STATE                     = 'PUSH_STATE';
export const RESTORE_STATE                  = 'RESTORE_STATE';
